// This file must not contain reference to another js file. This should contain only static functions or definitions reused in different parts.
// Except plot definition, which is only a definition of shared variables
import { SpecialDeleteName } from '@/common/plotDefinitions.js'
import { ExtraConfigKey, NameExtraConfig } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { getLinkedReportObj } from '@/common/sharedDefinitions/reportDefinitions'

/**
 * Retrieves linked report files for a given report.
 *
 * @param {Object} report - The report object containing details for which linked files are to be retrieved.
 * @returns {Promise<Array>} A promise that resolves to an array of linked report files.
 */
async function getLinkedReportFiles(report) {
  const linkedReportsObjt = await getLinkedReportObj(report);
  const linkedReportFiles = [];
  linkedReportsObjt.forEach(r => r.files.forEach(rf=> linkedReportFiles.push(JSON.parse(JSON.stringify(rf)))));
  linkedReportFiles.forEach(f => f.linkedFile = true);
  if(!report[ExtraConfigKey][NameExtraConfig.CopySource]
     && typeof(report[ExtraConfigKey][NameExtraConfig.LinkedReportChanges]) !== 'undefined'
     && Object.keys(report[ExtraConfigKey][NameExtraConfig.LinkedReportChanges]).length > 0
    ){
    for(const fileLinked of linkedReportFiles){
      if(typeof report[ExtraConfigKey][NameExtraConfig.LinkedReportChanges][fileLinked.name] === 'undefined')
        continue;
      const fileLinkModif = report[ExtraConfigKey][NameExtraConfig.LinkedReportChanges][fileLinked.name];
      for(const [indexDataline, properties] of Object.entries(fileLinkModif)){
        const dataline = fileLinked.extractedData[parseInt(indexDataline)]
        for(const [prop, value] of Object.entries(properties)){
          if(value === SpecialDeleteName){
            delete dataline[prop]
          }else{
            dataline[prop] = value
          }
        }
      }
    }
  }
  return linkedReportFiles;
}

/**
 * Retrieves linked report files for a given report.
 *
 * @param {Object} report - The report object containing details for which linked files are to be retrieved.
 * @returns {Promise<Array>} A promise that resolves to an array of linked report files.
 */
async function getLinkedReportFilesCount(report) {
  const linkedReportsObjt = await getLinkedReportObj(report);
  let countFiles = 0
  linkedReportsObjt.forEach(r => countFiles += r.files.lenght);
  return countFiles;
}

/**
 * Retrieves all files associated to the given report, i.e., files of report + linked reports
 *
 * @param {Object} report - The report object containing details for which associated files will be retrieved
 * @returns {Promise<Array>} A promise that resolves to an array with all files
 */
async function getReportFiles(report) {
  const linkedReportFiles = await getLinkedReportFiles(report);
  if (typeof report.files === 'undefined') {
    return linkedReportFiles;
  }
  return report.files.concat(linkedReportFiles);
}

/**
 * Retrieves the count of all files associated to the given report, i.e., files of report + linked reports
 *
 * @param {Object} report - The report object containing details for which associated files
 * @returns {Promise<Array>} A promise that resolves to an integer with the amount of files
 */
async function getReportFilesCount(report) {
  const linkedReportFilesCount = await getLinkedReportFilesCount(report);
  if (typeof report.files === 'undefined') {
    return linkedReportFilesCount;
  }
  return report.files.lenght + linkedReportFilesCount;
}

export {
    getReportFiles,
    getReportFilesCount,
};